import { Checkbox } from '@atlaskit/checkbox';

import React from 'react';
import { useSelector } from 'react-redux';

import config from 'appconfig';
import t from 'modules/i18n/intl';
import { State } from 'model/State';

import { selectRenewalTotal } from '../duck/selectors';
import { StyledValueWrapper, StyledWrapper } from './PaymentMethodsTable';
import { messages } from '../messages';

const contactUs = (chunks) => <a href={config.companyContact}>{chunks}</a>;

export const PaymentMethodRow = ({
  isChecked,
  product,
  name,
  sen,
  renewsOn,
  currentPaymentMethod,
  setAccountsSelected,
}) => {
  const estimatedPrice = useSelector((state) => selectRenewalTotal(state as State, sen));

  const onChange = () => {
    setAccountsSelected((prevState) => {
      if (!isChecked) {
        return [...prevState, sen];
      }
      return prevState.filter((item) => item !== sen);
    });
  };

  return (
    <StyledWrapper data-cy={`payment-method-row-${sen}`}>
      <StyledValueWrapper width="5%">
        <Checkbox data-cy={`row-checkbox-${sen}`} isChecked={isChecked} onChange={onChange} />
      </StyledValueWrapper>
      <StyledValueWrapper width="15%">
        <p>{product}</p>
      </StyledValueWrapper>
      <StyledValueWrapper width="15%">
        <p>{name}</p>
      </StyledValueWrapper>
      <StyledValueWrapper width="15%">
        <p>{`SEN-${sen}`}</p>
      </StyledValueWrapper>
      <StyledValueWrapper width="14%">
        <p>{renewsOn}</p>
      </StyledValueWrapper>
      <StyledValueWrapper width="16%">
        {estimatedPrice ? (
          <p>{estimatedPrice}</p>
        ) : (
          t(messages.unableToCalculateRenewal, { contactUs })
        )}
      </StyledValueWrapper>
      <StyledValueWrapper width="20%">
        <p>{currentPaymentMethod}</p>
      </StyledValueWrapper>
    </StyledWrapper>
  );
};
